import { Splits } from './splits';
export const createSplits = (settings) => {
    if (typeof settings !== 'object') {
        throw new Error('expected `settings` is object');
    }
    const { tests, options } = settings;
    if (!Array.isArray(tests) || !tests.length) {
        throw new Error('expected `settings.tests` is not empty array');
    }
    tests.forEach(({ name, variations }) => {
        if (!/^[A-Za-z0-9_-]+$/.test(name)) {
            throw new Error(`expected \`${name}\` contains \`A-Za-z0-9_-\` symbols only`);
        }
        if (!Array.isArray(variations) || !variations.length) {
            throw new Error(`expected \`variations\` of \`${name}\` is not empty array`);
        }
        variations.forEach(({ name: varName, probability }) => {
            if (!Array.isArray(probability) ||
                typeof probability[0] !== 'number' ||
                typeof probability[1] !== 'number') {
                throw new Error(`expected \`probability\` of \`${name}.${varName}\` is array of numbers`);
            }
        });
    });
    return new Splits({
        tests,
        options: {
            path: '/',
            expires: 182,
            domain: `.${window.location.hostname}`,
            samesite: 'none',
            secure: true,
            ...options
        }
    });
};
